<template>
  <div class="rui-overlay" :class="componentCSS">
    <slot />
  </div>
</template>

<script>
/**
 * Overlay with some options
 *
 * @noPlayground The component should be used inside other components
 */
export default {
  name: 'RuiOverlay',
  props: {
    /** Whether to make the overlay opaque */
    opaque: { required: false, type: Boolean, default: false },
    /** Whether to display a specific cursor. Useful when no actions are bound on it */
    disabled: { required: false, type: Boolean, default: false },
  },
  computed: {
    componentCSS () {
      return [
        this.opaque && 'rui-overlay--opaque',
        this.disabled && 'rui-overlay--disabled',
      ]
    },
  },
}
</script>
